var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 4.62143C12.953 4.62143 14.2704 5.46499 15.0215 6.16988L17.9566 3.3041C16.1539 1.62854 13.8081 0.600098 11.0001 0.600098C6.93258 0.600098 3.41969 2.93432 1.70947 6.33165L5.07214 8.94321C5.91569 6.43565 8.24992 4.62143 11.0001 4.62143Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.984 11.2312C20.984 10.3761 20.9147 9.75209 20.7644 9.10498H11V12.9645H16.7316C16.616 13.9236 15.992 15.3681 14.6053 16.3388L17.8871 18.881C19.8516 17.0668 20.984 14.3974 20.984 11.2312Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08365 13.057C4.8641 12.4099 4.73699 11.7166 4.73699 11.0001C4.73699 10.2837 4.8641 9.59033 5.0721 8.94322L1.70943 6.33167C1.00454 7.74144 0.600098 9.32455 0.600098 11.0001C0.600098 12.6757 1.00454 14.2588 1.70943 15.6686L5.08365 13.057Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 21.4001C13.8083 21.4001 16.1656 20.4757 17.8874 18.881L14.6056 16.3388C13.7274 16.9512 12.5487 17.3788 11.0003 17.3788C8.25008 17.3788 5.91586 15.5646 5.08386 13.057L1.72119 15.6686C3.43141 19.0659 6.93275 21.4001 11.0003 21.4001Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.a2a5f24312a7c3ae2e5fb50599a9022c.svg";
export { ForwardRef as ReactComponent };